<template>
    <div class="navbar">
        <!-- <nav class="deep-purple darken-3"> -->
        <nav class="" style="background-color: #001F52">
            <div class="container">
                <router-link :to="{ name: 'Offices' }" class="brand-logo left"><img src="..\..\assets\images\logo.png" height="55px;" style="padding-top:15px; margin-right: 12px;"></router-link>
                <ul class="left" style="margin-left: 40px; font-size: 1.2em">
                    <router-link :to="{ name: 'Locations' }"><span>OFFICE BOOKER</span></router-link>
                </ul>
                <ul class="right">
                    <li v-if="!user"><router-link :to="{ name: 'Signup' }">Signup/Login</router-link></li>
                    <span v-if="!loading">
                        <span v-if="user">
                            <li v-if="user.permission > 300"><router-link :to="{ name: 'Admin' }" v-tooltip="'User Permissions'"><i class="material-icons">admin_panel_settings</i></router-link></li>
                            <li v-if="user.permission > 200"><router-link :to="{ name: 'AllOffices' }" v-tooltip="'All Offices'"><i class="material-icons">apartment</i></router-link></li>
                            <li v-if="user.permission > 200"><router-link :to="{ name: 'AllUnapproved' }" v-tooltip="'Approve Bookings'"><i class="material-icons">grading</i></router-link></li>
                            <li v-if="user.permission > 100"><router-link :to="{ name: 'AllBookings' }" v-tooltip="'All Reservations'"><i class="material-icons">date_range</i></router-link></li>
                        </span>
                    </span>
                    <li v-if="user"><router-link :to="{ name: 'MyBookings' }" v-tooltip="'My Reservations'"><i class="material-icons">perm_contact_calendar</i></router-link></li>
                    <li v-if="user"><router-link :to="{ name: 'Profile' }" v-tooltip="'My Profile'"><i class="material-icons">settings</i></router-link></li>
                    <li v-if="user"><a @click="logout"><i class="material-icons" v-tooltip="'Log Out'">exit_to_app</i></a></li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
export default {
    name: 'Navbar',
    data() {
        return {
            user: null,
            loading: true
        }
    },
    methods: {
        logout() {
            firebase.auth().signOut().then(()=>{
                this.$router.push({ name: 'Login' })
            });
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(async (user) => {
            if(user){
                
                var collection = db.collection('users').where("email", "==", user.email);
                const answer = await collection.get();

                // console.log(answer)
                answer.forEach(doc => {
                    console.log(doc.data())
                    if(doc.data().oldEmail){
                        user.old_email = doc.data().oldEmail;
                    } else {
                        user.old_email = null;
                    }
                });

                this.user = user
                var userdb = null;
                 var collection = null;

                if(user.old_email){
                    console.log("User has an old email address: " + user.old_email)
                    collection = db.collection('users').where("oldEmail", "==", user.old_email)
                } else {
                    console.log("User does not have an old email address.")
                    collection = db.collection('users').where("user_id", "==", user.uid)
                }
                
                var data = await collection.get();

                data.forEach(doc => {
                    userdb = doc.data()
                    console.log(userdb.permission)
                    this.user.permission = userdb.permission
                });

                this.loading = false;

            } else {
                this.user = null
                this.loading = false;
            }
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layout/Navbar.vue